import { render } from "./Detail.vue?vue&type=template&id=110c8cac&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=110c8cac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-110c8cac"

export default script